import { FC, useCallback } from 'react';
import styles from './styles.module.scss';

type Props = {
    text: string;
    primary?: boolean;
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
    className?: string;
};

export const Button: FC<Props> = ({ text, disabled, className, loading = false, onClick }) => {
    const _onClick = useCallback(
        (event: any) => {
            event.preventDefault();

            if (onClick && !disabled && !loading) {
                onClick();
            }
        },
        [onClick, disabled, loading],
    );

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
            className={`${styles.button} ${disabled ? styles.disabled : ''} ${loading ? styles.loading : ''} ${className}`}
            onClick={_onClick}
        >
            {loading && <span className={styles.spinner} aria-hidden="true" />}
            <span className={styles.label}>{text}</span>
        </a>
    );
};
